import React from "react";

export const CondenserIcon = () => {
  return (
    <svg
      width="30"
      height="37"
      viewBox="0 0 30 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 0.583313C5.45038 8.7354 0.666626 15.7766 0.666626 21.725C0.666626 30.6475 7.47496 36.4166 15 36.4166C22.525 36.4166 29.3333 30.6475 29.3333 21.725C29.3333 15.7766 24.5495 8.7354 15 0.583313ZM15 32.8333C8.99788 32.8333 4.24996 28.2287 4.24996 21.725C4.24996 17.5325 7.74371 11.9783 15 5.34915C22.2562 11.9783 25.75 17.5146 25.75 21.725C25.75 28.2287 21.002 32.8333 15 32.8333ZM7.52871 22.0833C8.19163 22.0833 8.72913 22.5491 8.85454 23.1941C9.58912 27.1716 12.9395 28.5333 15.3762 28.3362C16.1466 28.3004 16.7916 28.9096 16.7916 29.68C16.7916 30.3966 16.2183 30.9879 15.5016 31.0237C11.6854 31.2566 7.22413 29.0708 6.20288 23.6421C6.05954 22.8358 6.70454 22.0833 7.52871 22.0833Z" />
    </svg>
  );
};
